import {
  ADD_JopTitle,
  GET_JopTitle,
  UPDATE_JopTitle,
  DELETE_JopTitle,
} from "../type";
import { InsertData, InsertDataWithImage } from "../../Hooks/InsertData";
import { GetDataToken } from "../../Hooks/getAllData";
import { InsUpdateData } from "../../Hooks/UpdataData";
import DeleteData from "../../Hooks/DeleteData";
export const CreateJopTitleAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertData(`/api/JopTitle`, data);
    dispatch({
      type: ADD_JopTitle,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: ADD_JopTitle,
      payload: "Error" + e,
    });
  }
};
export const GetAllJopTitleAction = () => async (dispatch) => {
  try {
    const respons = await GetDataToken(`/api/JopTitle`);
    dispatch({
      type: GET_JopTitle,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: GET_JopTitle,
      payload: "Error" + e,
    });
  }
};
export const UpdateJopTitleAction = (body) => async (dispatch) => {
  try {
    const respons = await InsUpdateData(`/api/JopTitle`, body);
    dispatch({
      type: UPDATE_JopTitle,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: UPDATE_JopTitle,
      payload: "Error" + e,
    });
  }
};

export const DeleteJopTitleAction = (Id) => async (dispatch) => {
  try {
    const respons = await DeleteData(`/api/JopTitle?id=${Id}`);
    dispatch({
      type: DELETE_JopTitle,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: DELETE_JopTitle,
      payload: "Error" + e,
    });
  }
};
